import httpClient from "./httpClient";

// Avisos do carrossel do hub. Leitura para qualquer usuário; o resto é da administração.
export async function listarAvisosVigentes() {
  const response = await httpClient.get("/api/avisos");
  return Array.isArray(response.data) ? response.data : [];
}

export async function listarAvisosParaGestao() {
  const response = await httpClient.get("/api/avisos/gestao");
  return Array.isArray(response.data) ? response.data : [];
}

export async function criarAviso(payload) {
  const response = await httpClient.post("/api/avisos", payload);
  return response.data;
}

export async function atualizarAviso(id, payload) {
  const response = await httpClient.put(`/api/avisos/${id}`, payload);
  return response.data;
}

export async function enviarImagemAviso(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await httpClient.post(`/api/avisos/${id}/imagem`, formData);
  return response.data;
}

export async function excluirAviso(id) {
  await httpClient.delete(`/api/avisos/${id}`);
}
